import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { updateContactDataOfContact } from '../../Utility/UpdateContactData/UpdateContactData';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { setAllDataOfContact } from '../../Redux/Index';
import { useDispatch } from 'react-redux';

// Redux func start

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact
  }
}

// Redux func end

function ContactDetail({ allDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const originalId = id.substring(9, id.length - 4);

  const [isDataSubmitting, setIsDataSubmitting] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [contactData, setContactData] = useState({
    Id: originalId
  });

  useEffect(() => {

    if((allDataOfContact) && (allDataOfContact.success)) {
      setIsLoading(false);
    }

    if(Object.keys(contactData).length === 1) {
      if(allDataOfContact.data && allDataOfContact.data.Contacts) {
        allDataOfContact.data.Contacts.records.forEach((rowData) => {
          if(rowData.Id == originalId) {
            setContactData(rowData);
            return;
          }
        });
      }
  
    } 
    
  }, [allDataOfContact, isLoading, contactData]);


  // Input field value handler start

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setContactData({
      ...contactData,
      [name]: value,
    });
  };

  // Input field value handler end

  // Input field error handler start

  const nameFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Name" && value=="") {
        setNameError(true);
    } else {
        setNameError(false);
    }
  }

  // Input field error handler end

  // Contact submit func start

  function submitContactData() {
    loginTimeOutAndRedirectHandler(updateContactDataOfContact, contactData, dispatch, setAllDataOfContact, navigate, "/", "Contact detail updated!", setIsDataSubmitting, "/Contacts");
  }

  // Contact submit func start

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', marginLeft: 2, marginBottom: 2, fontWeight: 'bold' }}
            >
              My Profile
            </Typography>
        <CssBaseline />
        { Object.keys(contactData).length === 1 ?  <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}><CircularProgress /></Box> : <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
          <InputLabel htmlFor="name" style={{ textAlign: "left" }}><span style={{ color: 'red' }}>*</span> Name</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="name"
              type="text"
              required
              error={nameError}
              name="Name"
              placeholder="Enter Name"
              helperText={nameError ? 'Name is required!' : ''} 
              value={contactData.Name == null ? "" : contactData.Name}
              onChange={(e) => { nameFieldErrorHandler(e);handleInputChange(e); }}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="phone" style={{ textAlign: "left" }}>Phone</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="phone"
              name="Phone"
              value={contactData.Phone == null ? "" : contactData.Phone}
              placeholder="Enter Phone"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="email" style={{ textAlign: "left" }}>Email</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="email"
              type="email"
              value={contactData.Email == null ? "" : contactData.Email}
              name="Email"
              placeholder="Enter Email Address"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="status" style={{ textAlign: "left", marginBottom: "1rem" }}>Status</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="status"
                value={(contactData.Status__c == "--None--" || contactData.Status__c == null) ? "--None--" : contactData.Status__c}
                name="Status__c"
                placeholder="Select Status"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Active"}>Active</MenuItem>
                <MenuItem value={"Inactive"}>Inactive</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="mobile" style={{ textAlign: "left" }}>Mobile</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="mobile"
              name="MobilePhone"
              value={contactData.MobilePhone == null ? "" : contactData.MobilePhone}
              placeholder="Enter Mobile"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="accountName" style={{ textAlign: "left" }}>Account Name</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              id="accountName"
              name="AccountName"
              value={contactData.Account.Name == null ? "" : contactData.Account.Name}
              placeholder="Enter Account Name"
              InputProps={{
                readOnly: true
              }}
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={2} md={6} lg={8}>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => { setIsDataSubmitting(true);submitContactData() }}
              disabled={ contactData.Name == "" ? true : false }
            >
              { isDataSubmitting ? <CircularProgress size={24} style={{ color: "white" }} /> : "Update" }
            </Button>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Link to="/Contacts" style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="submit"
              fullWidth
              variant="outlined"
              sx={{ mt: 3, mb: 2 }}
            >
              Cancel
            </Button>
            </Link>
            </Grid>
          </Grid>
        </Box> }
        


          </Container>
  )
}

export default connect(mapStateToPropsForAllData)(ContactDetail);